/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  function initFeaturedCollectionsSection(section) {
    if (window.innerWidth <= 800) return;

    var $section = $(section);
    var sr = ScrollReveal();

    var $title = $section.find('.featured-collections__title');
    if ($title.length) {
      sr.reveal($title[0], {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }

    var $description = $section.find('.featured-collections__description');
    if ($description.length) {
      sr.reveal($description[0], {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }

    var cards = $section.find('.featured-collections__card').toArray();
    if (cards.length) {
      sr.reveal(cards, {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        interval: 40,
        once: true
      });
    }
  }

  function initAllFeaturedCollectionsSections() {
    document.querySelectorAll('.featured-collections').forEach(function (section) {
      if (section.dataset.fcInit) return;
      section.dataset.fcInit = 'true';
      initFeaturedCollectionsSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFeaturedCollectionsSections);
  } else {
    initAllFeaturedCollectionsSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.classList && event.target.classList.contains('featured-collections')
      ? event.target
      : event.target.querySelector && event.target.querySelector('.featured-collections');
    if (section) {
      delete section.dataset.fcInit;
      initFeaturedCollectionsSection(section);
      section.dataset.fcInit = 'true';
    }
  });
})();